import { Grid } from '../core/Grid.js';

/** Fill colour for the digit cells, picked by grid kind. */
function previewFill(isImported: boolean, isVortex: boolean): string {
    return isImported ? '#f4a261' : isVortex ? '#a78bfa' : '#4ecdc4';
}

/**
 * Draw the small square grid preview (digit cells as coloured blocks) used on
 * grid cards in the selector and the duplicate modal. The canvas is assumed to
 * be square; cell size derives from its width.
 */
export function renderGridPreview(
    canvas: HTMLCanvasElement,
    gridData: string,
    opts: { isImported?: boolean; isVortex?: boolean } = {},
): void {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const grid = Grid.deserialize(gridData);
    const size = canvas.width;
    const cellSize = size / grid.size;

    // Background
    ctx.fillStyle = '#1a1a2e';
    ctx.fillRect(0, 0, size, size);

    // Grid lines (subtle)
    ctx.strokeStyle = '#2a2a4e';
    ctx.lineWidth = 0.5;
    for (let i = 0; i <= grid.size; i++) {
        ctx.beginPath();
        ctx.moveTo(i * cellSize, 0);
        ctx.lineTo(i * cellSize, size);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, i * cellSize);
        ctx.lineTo(size, i * cellSize);
        ctx.stroke();
    }

    // Fill digit cells with coloured squares
    ctx.fillStyle = previewFill(!!opts.isImported, !!opts.isVortex);
    for (let digit = grid.minDigit; digit <= grid.maxDigit; digit++) {
        const pos = grid.getDigitPosition(digit);
        if (pos) {
            ctx.fillRect(pos.col * cellSize + 1, pos.row * cellSize + 1, cellSize - 2, cellSize - 2);
        }
    }
}
